import Logo from "../../../../../assets/PreviewPageV2/img/logo.jpg";
import { useEffect, useState } from "react";

import {
  ApplythisFollowingOD,
  furtherBorrows,
  furtherBorrowsNew,
  wereUalreadyPayingOD,
} from "../../../../../Constants/Questions";

export default function QuestionariePreview({ questionData }) {
  const [occasionalUnseenEmergency, setOccasionalUnseenEmergency] =
    useState("");
  const [applythisFollowing, setApplythisFollowing] = useState([]);
  const [offerLoans, setOfferLoans] = useState("");
  const [odopeningCredit, setOdopeningCredit] = useState("");
  const [recentCredit, setRecentCredit] = useState();
  const [irresponsibleAct, setIrresponsibleAct] = useState();
  const [highestCreditLimit, setHighestCreditLimit] = useState("");
  const [exceedCreditLimit, setExceedCreditLimit] = useState();
  const [timesExceedLimit, setTimesExceedLimit] = useState("");
  const [overlimitCharge, setOverlimitCharge] = useState("");
  const [finHardship, setFinHardship] = useState();
  const [didReceiveIncome, setDidReceiveIncome] = useState();
  const [cardMonthlyIncome, setCardMonthlyIncome] = useState("");
  const [dependent, setDependent] = useState();
  const [question79, setQuestion79] = useState([]);
  const [slide80, setSlide80] = useState([]);
  const [didTakeFurtherBorrowing, setDidTakeFurtherBorrowing] = useState();
  const [furtherBorrow, setFurtherBorrow] = useState([]);
  const [essentialRepayment, setEssentialRepayment] = useState();
  const [maintainBalance, setMaintainBalance] = useState();
  const [stuckOverdraft, setStuckOverdraft] = useState("");
  const [stuckOverdraftAffect, setStuckOverdraftAffect] = useState();

  const [userMortages, setUserMortage] = useState("");
  const [userRentss, setUserRent] = useState("");
  const [userTotalUtilityBillss, setUserTotalUtilityBills] = useState("");
  const [userMonthlyLoanRepaymentss, setUserMonthlyLoanRepayments] =
    useState("");
  const [userCreditCardRepaymentss, setUserCreditCardRepayments] = useState("");
  const [userMonthlyCarFinancess, setUserMonthlyCarFinance] = useState("");
  const [userMonthlyStoreCardPaymentss, setUserMonthlyStoreCardPayments] =
    useState("");
  const [userOtherMonthlyPaymentss, setUserOtherMonthlyPayments] = useState("");
  const [userPayDayLoans, setUserPayDayLoans] = useState("");
  const [borrowingterm, setBorrowingterm] = useState("");
  const [closedYear, setClosedYear] = useState("");


  useEffect(() => {
    if (questionData?.OccasionalUnforeseenEmergency) {
      setOccasionalUnseenEmergency(
        "I often used my overdraft for a prolonged period and for day-to -day expenditure (e.g. if you were often living in your overdraft)"
      );
    }
    if (questionData?.applythisFollowing) {
      let applythisFollowing = JSON.parse(questionData?.applythisFollowing);

      if (applythisFollowing?.length > 0) {
        applythisFollowing.forEach((ele) => {
          const foundopts = ApplythisFollowingOD?.answers.find(
            (obj) => obj.value == ele.id
          );
          if (foundopts && foundopts.value) {
            setApplythisFollowing((prev) => [foundopts?.label, ...prev]);
          }
        });
      }
    }
    setOfferLoans(questionData?.offerLoans || "");
    setOdopeningCredit(questionData?.odopeningCredit || "");
    setRecentCredit(questionData?.recentCredit || null);
    setIrresponsibleAct(questionData?.irresponsibleAct || null);
    setHighestCreditLimit(questionData?.highestCreditLimit || "");
    setExceedCreditLimit(questionData?.exceedCreditLimit || null);
    setTimesExceedLimit(questionData?.timesExceedLimit || "");
    setOverlimitCharge(questionData?.overlimitCharge || "");
    setFinHardship(questionData?.finHardship || null);
    setDidReceiveIncome(questionData?.didReceiveIncome || null);
    setCardMonthlyIncome(questionData?.cardMonthlyIncome || "");
    setDependent(questionData?.dependent || null);
    setClosedYear(questionData?.closedYear || null);

    if (questionData?.quest_79) {
      let quest_79 = JSON.parse(questionData?.quest_79);

      if (quest_79?.length > 0) {
        quest_79.forEach((ele) => {
          const foundopts = wereUalreadyPayingOD?.answers.find(
            (obj) => obj.value == ele.id
          );
          if (foundopts && foundopts.value) {
            setQuestion79((prev) => [foundopts?.label, ...prev]);
          }
        });
      }
    }
    setSlide80(questionData?.newiande || []);
    setDidTakeFurtherBorrowing(questionData?.didtakefurtherborrowing || null);
    if (questionData?.furtherBorrow) {
      let furtherBorrow = JSON.parse(questionData?.furtherBorrow);

      if (furtherBorrow?.length > 0) {
        furtherBorrow.forEach((ele) => {
          const foundopts = (furtherBorrowsNew || furtherBorrows)?.answers.find(
            (obj) => obj.value == ele.id
          );
          if (foundopts && foundopts.value) {
            setFurtherBorrow((prev) => [foundopts?.label, ...prev]);
          }
        });
      }
    }
    setEssentialRepayment(questionData?.essentialRepayment || null);
    setMaintainBalance(questionData?.maintainBalance || null);
    setStuckOverdraft(questionData?.stuckOverdraft || "");
    setStuckOverdraftAffect(questionData?.stuckOverdraftAffect || "");
  }, [questionData]);

  useEffect(() => {
    if (slide80.length > 0) {
      let slide80find = JSON.parse(slide80);

      let userMortage_find = slide80find.find((arr) => arr[0] === "228");
      if (userMortage_find) {
        setUserMortage(userMortage_find[1] || "");
      }

      let userRent_find = slide80find.find((arr) => arr[0] === "229");
      if (userRent_find) {
        setUserRent(userRent_find[1] || "");
      }

      let userTotalUtilityBills_find = slide80find.find(
        (arr) => arr[0] === "230"
      );
      if (userTotalUtilityBills_find) {
        setUserTotalUtilityBills(userTotalUtilityBills_find[1] || "");
      }

      let userMonthlyLoanRepayments_find = slide80find.find(
        (arr) => arr[0] === "231"
      );
      if (userMonthlyLoanRepayments_find) {
        setUserMonthlyLoanRepayments(userMonthlyLoanRepayments_find[1] || "");
      }

      let userCreditCardRepayments_find = slide80find.find(
        (arr) => arr[0] === "232"
      );
      if (userCreditCardRepayments_find) {
        setUserCreditCardRepayments(userCreditCardRepayments_find[1] || "");
      }

      let userMonthlyCarFinance_find = slide80find.find(
        (arr) => arr[0] === "233"
      );
      if (userMonthlyCarFinance_find) {
        setUserMonthlyCarFinance(userMonthlyCarFinance_find[1] || "");
      }

      let userMonthlyStoreCardPayments_find = slide80find.find(
        (arr) => arr[0] === "234"
      );
      if (userMonthlyStoreCardPayments_find) {
        setUserMonthlyStoreCardPayments(
          userMonthlyStoreCardPayments_find[1] || ""
        );
      }

      let userOtherMonthlyPayments_find = slide80find.find(
        (arr) => arr[0] === "235"
      );
      if (userOtherMonthlyPayments_find) {
        setUserOtherMonthlyPayments(userOtherMonthlyPayments_find[1] || "");
      }

      let userPayDayloans_find = slide80find.find((arr) => arr[0] === "296");
      if (userPayDayloans_find) {
        setUserPayDayLoans(userPayDayloans_find[1] || "");
      }
      let shortterm_find = slide80find.find((arr) => arr[0] === "297");
      if (shortterm_find) {
        setBorrowingterm(shortterm_find[1] || "");
      }
    }
  }, [slide80]);

  const ApplythisFollowingList = () => {
    if (applythisFollowing.length > 0) {
      return applythisFollowing.map((ps, index) => {
        return (
          <p key={index}>
            <span>&#10003;</span> {ps}
          </p>
        );
      });
    }
  };

  const MonthlyIncomeList = () => {
    if (question79.length > 0) {
      return question79.map((ps, index) => {
        return (
          <p key={index}>
            <span>&#10003;</span> {ps}
          </p>
        );
      });
    }
  };

  const FurtherBorrowList = () => {
    if (furtherBorrow.length > 0) {
      return furtherBorrow.map((ps, index) => {
        return (
          <p key={index}>
            <span>&#10003;</span> {ps}
          </p>
        );
      });
    }
  };

  return (
    <section className="container-1 my-5 declare-sec">
      <table>
        <tbody>
          <tr>
            <td>
              <table className="logo-tab">
                <tbody>
                  <tr>
                    <td style={{ textAlign: "center" }}>
                      <img style={{ width: 200, opacity: ".8" }} src={Logo} />
                    </td>
                  </tr>
                </tbody>
              </table>
              {/* Header */}
              <div style={{ clear: "both" }} />
              <h4
                style={{
                  fontSize: 24,
                  margin: "10px 0",
                  textAlign: "center",
                  color: "#2680d5",
                  fontWeight: 400,
                }}
              >
                Overdraft Questionnaire
              </h4>
              {closedYear && (
                <>
                  <p>
                    <b>
                    Was your account closed over 6 years ago?
                    </b>
                  </p>
                  <p>{closedYear === 377 ? "YES" : "NO"}</p>
                  <br />
                </>
              )}
              {occasionalUnseenEmergency!="" && (
                <>
                  <p>
                    <b>
                      Did you use your overdraft for the occasional unforeseen
                      emergency or was it used regularly for day-to-day
                      expenditure?
                    </b>
                  </p>
                  <p>{occasionalUnseenEmergency}</p>
                  <br />
                </>
              )}
              {applythisFollowing && applythisFollowing.length > 0 && (
                <>
                  <p>
                    <b>
                      While having an overdraft did any of the following apply:
                    </b>
                  </p>
                  <ApplythisFollowingList />
                  <br />
                </>
              )}
              {offerLoans.length > 0 && (
                <>
                  <p>
                    <b>
                      Did the overdraft provider (your bank) offer you one of
                      their own loans to reduce your overdraft?
                    </b>
                  </p>
                  <p>{offerLoans}</p>
                  <br />
                </>
              )}
              {odopeningCredit.length > 0 && (
                <>
                  <p>
                    <b>What was your overdraft opening credit limit?</b>
                  </p>
                  <p>{odopeningCredit}</p>
                  <br />
                </>
              )}
              {recentCredit && (
                <>
                  <p>
                    <b>Was your credit limit ever increased?</b>
                  </p>
                  <p>{recentCredit == "247" ? "YES" : "NO"}</p>
                  <br />

                  {recentCredit == "247" && (
                    <>
                      <p>
                        <b>
                          The bank acted irresponsibly by increasing my
                          overdraft limit without conducting a proper
                          affordability assessment - do you agree?
                        </b>
                      </p>
                      <p>{irresponsibleAct == "249" ? "Agree" : "Disagree"}</p>
                      <br />
                      <p>
                        <b>
                          What is the highest credit limit you had on your
                          overdraft?
                        </b>
                      </p>
                      <p>{highestCreditLimit}</p>
                      <br />
                    </>
                  )}
                </>
              )}
              {exceedCreditLimit && (
                <>
                  <p>
                    <b>Did you ever exceed your credit limit?</b>
                  </p>
                  <p>{exceedCreditLimit == "251" ? "YES" : "NO"}</p>
                  <br />
                </>
              )}
              {exceedCreditLimit == "251" && (
                <>
                  <p>
                    <b>How often did you exceed your credit limit?</b>
                  </p>
                  <p>{timesExceedLimit}</p>
                  <br />

                  <p>
                    <b>Did you receive overlimit charges?</b>
                  </p>
                  <p>{overlimitCharge}</p>
                  <br />
                </>
              )}
              {finHardship && (
                <>
                  <p>
                    <b>
                      I have suffered financial hardship due to interest and
                      charges being applied to my account - do you agree?
                    </b>
                  </p>
                  <p>{finHardship == "265" ? "Agree" : "Disagree"}</p>
                  <br />
                </>
              )}
              {didReceiveIncome && (
                <>
                  <p>
                    <b>
                      In the year when you took the overdraft did you receive
                      any income?
                    </b>
                  </p>
                  <p>{didReceiveIncome == "267" ? "YES" : "NO"}</p>

                  <br />
                  {didReceiveIncome == "267" && cardMonthlyIncome != "" && (
                    <>
                      <p>
                        <b>
                          When you took out your overdraft, what was your
                          monthly income?
                        </b>
                      </p>
                      <p>{cardMonthlyIncome}</p>
                      <br />
                    </>
                  )}
                </>
              )}

              {dependent && dependent != "" && (
                <>
                  <p>
                    <b>How many dependents did you have at that time?</b>
                  </p>
                  <p>{dependent}</p>
                  <br />
                </>
              )}

              {question79 && question79.length > 0 && (
                <>
                  <p>
                    <b>
                      When I took the overdraft I was already paying monthly for
                      one or more of the following:
                    </b>
                  </p>
                  <MonthlyIncomeList />
                  <br />
                </>
              )}

              {/* {slide80 && (
                <>
                  <p>
                    <b>
                      {" "}
                      Please confirm the following MONTHLY / ANNUAL income and
                      expenditure details
                    </b>
                  </p>

                  {(userMortages || userRentss) && (
                    <p>
                      My monthly Mortgage / Rent was:
                      {userMortages || userRentss}
                    </p>
                  )}
                  {userTotalUtilityBillss && userTotalUtilityBillss != "" && (
                    <>
                      <p>
                        {" "}
                        My monthly TOTAL utility bills were:
                        {userTotalUtilityBillss}
                      </p>
                    </>
                  )}
                  {userMonthlyLoanRepaymentss &&
                    userMonthlyLoanRepaymentss != "" && (
                      <>
                        <p>
                          {" "}
                          My monthly loan repayments were:
                          {userMonthlyLoanRepaymentss}
                        </p>
                      </>
                    )}
                  {userCreditCardRepaymentss &&
                    userCreditCardRepaymentss != "" && (
                      <>
                        <p>
                          {" "}
                          My monthly credit card repayments were:
                          {userCreditCardRepaymentss}
                        </p>
                      </>
                    )}
                  {userMonthlyCarFinancess && userMonthlyCarFinancess != "" && (
                    <>
                      <p>
                        {" "}
                        My monthly car finance payments were:
                        {userMonthlyCarFinancess}
                      </p>
                    </>
                  )}
                  {userMonthlyStoreCardPaymentss &&
                    userMonthlyStoreCardPaymentss != "" && (
                      <>
                        <p>
                          {" "}
                          My monthly store card payments were:
                          {userMonthlyStoreCardPaymentss}
                        </p>
                      </>
                    )}
                  {userOtherMonthlyPaymentss &&
                    userOtherMonthlyPaymentss != "" && (
                      <>
                        <p>
                          {" "}
                          My other monthly payment commitments were:
                          {userOtherMonthlyPaymentss}
                        </p>
                      </>
                    )}
                  {userPayDayLoans && userPayDayLoans != "" && (
                    <>
                      <p>My PayDay loans were :{userPayDayLoans}</p>
                    </>
                  )}
                  {borrowingterm && borrowingterm != "" && (
                    <>
                      <p>
                        My Short term borrowing were:
                        {borrowingterm}
                      </p>
                    </>
                  )}
                  <br />
                </>
              )} */}

              {didTakeFurtherBorrowing && (
                <>
                  <p>
                    <b>
                      Did you take out further borrowing so that you could
                      manage your finances?
                    </b>
                  </p>
                  <p>{didTakeFurtherBorrowing === 312 ? "YES" : "NO"}</p>
                  <br />
                </>
              )}
              {furtherBorrow &&
                furtherBorrow.length > 0 &&
                didTakeFurtherBorrowing === 312 && (
                  <>
                    <p>
                      <b>Please select the type of borrowing you took:</b>
                    </p>
                    <FurtherBorrowList />
                    <br />
                  </>
                )}
              {essentialRepayment && (
                <>
                  <p>
                    <b>
                      Have you struggled to meet your essential repayments as a
                      result of being in your overdraft?
                    </b>
                  </p>
                  <p>{essentialRepayment == "286" ? "YES" : "NO"}</p>
                  <br />
                </>
              )}
              {maintainBalance && (
                <>
                  <p>
                    <b>
                      I had not maintained a credit balance for a significant
                      period of time which ought to have made the bank aware of
                      my financial difficulties - do you agree?
                    </b>
                  </p>
                  <p>{maintainBalance == "288" ? "Agree" : "Disagree"}</p>
                  <br />
                </>
              )}
              {stuckOverdraft && (
                <>
                  <p>
                    <b>
                      I was stuck in my overdraft and didn’t see a positive
                      balance
                    </b>
                  </p>
                  <p>{stuckOverdraft}</p>
                  <br />
                </>
              )}
              {stuckOverdraft != "Never" && stuckOverdraftAffect != "" && (
                <>
                  <p>
                    <b>
                      You’ve told us you were stuck in your overdraft, as a
                      result you didn’t see a frequent positive balance – how
                      did this affect you?
                    </b>
                  </p>
                  <p>{stuckOverdraftAffect}</p>
                  <br />
                </>
              )}
              <br />
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  );
}
